import { render, staticRenderFns } from "./AboutVision.vue?vue&type=template&id=dc0ed790&scoped=true"
import script from "./AboutVision.vue?vue&type=script&lang=js"
export * from "./AboutVision.vue?vue&type=script&lang=js"
import style0 from "./AboutVision.vue?vue&type=style&index=0&id=dc0ed790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0ed790",
  null
  
)

export default component.exports